// extracted by mini-css-extract-plugin
module.exports = {"ModalFonts":"styles_ModalFonts__3oYTR"};